import React, { useState } from "react";

import Content from "../../commons/components/content"
import {
    Card,
    ColTitle,
    RowFilters
} from './styles';

import { infoTexts } from './infoTexts';


function Privacy() {
    const renderInfoCards = () => (
        <>
            {infoTexts.map(({ title, texts }) => (
                <Card key={title}>
                    <strong>{title}</strong>

                    {texts.map(text => (
                        <p>{text}</p>
                    ))}
                </Card>
            ))}
        </>
    );

    const renderHeader = () => (
        <RowFilters>
            <ColTitle flex="auto">
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div>
                        <h2 className={"dados-header"}>Privacidade - LGPD</h2>
                        <span className="dados-header-subtitle">
                            Este menu de privacidade destina-se a ajudar você a entender como serão utilizados seus dados
                        </span>
                    </div>
                </div>
            </ColTitle>
        </RowFilters>

    );

    return (
        <Content>
            {renderHeader()}
            {renderInfoCards()}
        </Content>
    )
}

export default Privacy;
